var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6915_10385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58105 8.12501C6.85085 8.48384 7.19506 8.78075 7.59034 8.9956C7.98562 9.21045 8.42273 9.33821 8.872 9.37022C9.32128 9.40223 9.77222 9.33774 10.1942 9.18112C10.6163 9.02451 10.9995 8.77943 11.3179 8.46251L13.2026 6.58751C13.7748 5.99813 14.0914 5.20875 14.0843 4.38938C14.0771 3.57002 13.7468 2.78623 13.1644 2.20683C12.582 1.62743 11.7941 1.29877 10.9705 1.29165C10.1469 1.28453 9.35346 1.59952 8.76103 2.16876L7.68046 3.23751",
    stroke: "#6C5CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09417 6.87499C8.82437 6.51616 8.48016 6.21925 8.08488 6.0044C7.6896 5.78955 7.2525 5.66179 6.80322 5.62978C6.35394 5.59777 5.903 5.66226 5.48098 5.81887C5.05896 5.97549 4.67573 6.22057 4.35729 6.53749L2.47258 8.41249C1.90039 9.00187 1.58378 9.79125 1.59094 10.6106C1.5981 11.43 1.92845 12.2138 2.51085 12.7932C3.09325 13.3726 3.88109 13.7012 4.70469 13.7083C5.5283 13.7155 6.32176 13.4005 6.9142 12.8312L7.98848 11.7625",
    stroke: "#6C5CE7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6915_10385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0776,
    height: 15,
    fill: "white",
    transform: "translate(0.298828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainBold);
export default __webpack_public_path__ + "static/media/chain-bold.1da717c533968689f2dd5a8b68081fec.svg";
export { ForwardRef as ReactComponent };